<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-overlay :show="unitLoad">
              <b-row>
                <b-col lg="12" sm="12" class="form-for-textarea">
                  <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                    <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset">
                      <b-row>
                        <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                          <ValidationProvider name="Dealer/ Retailer" vid='user_id' rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                :label="$t('sales_distribution_admin.sales_center') + ' *'"
                                label-for="user_id"
                                slot-scope="{ valid, errors }"
                                >
                                <b-form-select
                                plain
                                v-model="dataArray.user_id"
                                :options="agentNameList"
                                id="user_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback d-block">
                                    {{ errors[0] }}
                                  </div>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                          <ValidationProvider name="Delivery Order" vid='delivery_id' rules="required|min_value:1">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                :label="$t('retailerManagement.delivery_order_id') + '*'"
                                label-for="delivery_id"
                                slot-scope="{ valid, errors }"
                                >
                                <b-form-select
                                plain
                                v-model="dataArray.delivery_id"
                                :options="orderIdList"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback d-block">
                                    {{ errors[0] }}
                                  </div>
                            </b-form-group>
                          </ValidationProvider>
                        </b-col>
                      </b-row>
                      <b-table-simple striped bordered small>
                          <b-tr style="background-color: #66CC99; color: white">
                              <b-th class="text-center">{{ $t('globalTrans.select') }}</b-th>
                              <b-th class="text-center">{{ $t('globalTrans.sl_no') }}</b-th>
                              <b-th>{{ $t('production_store.pro_category') }}</b-th>
                              <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                              <b-th>{{ $t('retailerManagement.unit') }}</b-th>
                              <b-th>{{ $t('retailerManagement.quantity') }}</b-th>
                              <b-th>{{ $t('retailerManagement.received_quantity') }}</b-th>
                              <b-th>{{ $t('globalTrans.return') + ' ' + $t('retailerManagement.quantity') }}</b-th>
                              <b-th>{{ $t('retailerManagement.wasted_product') }}</b-th>
                              <b-th>{{ $t('retailerManagement.good_product') }}</b-th>
                              <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                              <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                          </b-tr>
                          <b-tr v-for="(item, index) in dataArray.details" :key="index">
                              <b-td class="text-center align-middle">
                                <b-form-checkbox
                                    :id="'checkbox-1'+index"
                                    v-model="item.select"
                                    :name="'checkbox-1'+index"
                                    :value=1
                                    :unchecked-value=0
                                >
                                </b-form-checkbox>
                              </b-td>
                              <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                              <b-td>{{ getCategoryName(item.product_id) }}</b-td>
                              <b-td>{{ productNameById(item.product_id) }}</b-td>
                              <b-td>{{ unitNameById(item.unit_id) }}</b-td>
                              <b-td>{{ $n(item.quantity - item.returned_quantity) }}</b-td>
                              <b-td>{{ item.received_quantity }}</b-td>
                              <b-td v-if="item.select">
                                  <ValidationProvider name="Return Quantity" :rules="'max_value:'+(item.quantity - (item.received_quantity + item.returned_quantity))+'|min_value:1|numeric|required'">
                                      <b-form-group
                                        class="mb-0"
                                        slot-scope="{ valid, errors }"
                                      >
                                          <b-form-input
                                            type="number"
                                            v-model="item.return_quantity"
                                            @input="changeQty(item)"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                            {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-td>
                              <b-td v-else>{{ $i18n.locale == 'en' ? 'Select Product' : 'পণ্য নির্বাচন করুন' }}</b-td>
                              <b-td v-if="item.select">
                                  <ValidationProvider name="Wasted Product Qty" :rules="'max_value:'+item.return_quantity+'|numeric|required'">
                                      <b-form-group
                                        class="mb-0"
                                        slot-scope="{ valid, errors }"
                                      >
                                          <b-form-input
                                            type="number"
                                            v-model="item.wasted_product_qty"
                                            @input="changeWastedQty(item)"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                            {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                              </b-td>
                              <b-td v-else>{{ $i18n.locale == 'en' ? 'Select Product' : 'পণ্য নির্বাচন করুন' }}</b-td>
                              <b-td>{{ $n(item.good_product_qty) }}</b-td>
                              <b-td>{{ $n(item.unit_price) }}</b-td>
                              <b-td>{{ $n(item.total) }}</b-td>
                          </b-tr>
                          <b-td colspan="11">
                              <p style="margin-left:85%">{{ $t('sales_distribution_admin.grand_price') }}</p>
                          </b-td>
                          <b-td>{{ $n(sumTotal) }}</b-td>
                          <b-tr v-if="dataArray.details.length > 0">
                            <b-td colspan="12">
                                <b-col lg="12" sm="12">
                                  <b-row>
                                    <b-col lg="4" sm="12">
                                      <label class="mr-4">{{ $t('retailerManagement.delivery_date') + ': ' }}</label>
                                      <span class="text-dark">{{ dataArray.delivery_date | dateFormat }}</span>
                                    </b-col>
                                    <b-col lg="4" sm="12">
                                      <label class="mr-4">{{ $t('retailerManagement.contact_no') + ': ' }}</label>
                                      <span class="capitalize">{{ dataArray.contact_no | mobileNumber }}</span>
                                    </b-col>
                                    <b-col lg="4" sm="12">
                                      <label class="mr-4">{{ $t('retailerManagement.delivery_location') + ': ' }}</label>
                                      <span class="capitalize">{{ dataArray.delivery_location }}</span>
                                    </b-col>
                                  </b-row>
                                </b-col>
                            </b-td>
                          </b-tr>
                      </b-table-simple>
                      <b-row>
                        <b-col lg="12" sm="12">
                            <p class="text-muted font-weight-bold">
                                <span v-if="$i18n.locale === 'en'">
                                  [Note: * Selected products will be counted as returned products. Central stock will decremented according to wasted product quantity and incremented according to good product quantity.
                                  <br>* Unselected products will not be considered as return products.]
                                </span>
                                <span v-else>[বি.দ্র: * নির্বাচিত পণ্য ফেরত পণ্য হিসাবে গণনা করা হবে। নষ্ট পণ্যের পরিমাণ অনুযায়ী কেন্দ্রীয় স্টক হ্রাস পাবে এবং ভাল পণ্যের পরিমাণ অনুযায়ী বৃদ্ধি পাবে।
                                  <br>*অনির্বাচিত পণ্যগুলি রিটার্ন পণ্য হিসাবে বিবেচিত হবে না।]
                                </span>
                            </p>
                        </b-col>
                        <b-col lg="6" sm="12">
                          <ValidationProvider name="Return Date" vid='return_date' rules="required">
                            <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="return_date"
                            slot-scope="{ valid, errors }"
                            >
                            <template v-slot:label>
                              {{ $t('externalUser.production.return_date')}} <span class="text-danger">*</span>
                            </template>
                            <flat-pickr
                              :config="{ static: true }"
                              class="form-control disabled"
                              id="return_date"
                              placeholder="Select Date"
                              v-model="dataArray.return_date"
                              :state="errors[0] ? false : (valid ? true : null)"
                            >
                            </flat-pickr>
                              <div class="invalid-feedback d-block">
                                {{ errors[0] }}
                              </div>
                            </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12"></b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Comment (En)" vid='comments' rules="required">
                                <b-form-group
                                class="row"
                                label-cols-sm="12"
                                label-for="comments"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                  {{ $t('production_store.comment_en')}} <span class="text-danger">*</span>
                                </template>
                                <b-textarea
                                id="note"
                                v-model="dataArray.comments"
                                :state="errors[0] ? false : (valid ? true : null)"
                                ></b-textarea>
                                <div class="invalid-feedback">
                                  {{ errors[0] }}
                                </div>
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col lg="6" sm="12">
                            <ValidationProvider name="Comment (Bn)" vid='comments_bn' rules="required">
                              <b-form-group
                              class="row"
                              label-cols-sm="12"
                                    label-for="comments_bn"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                      {{ $t('production_store.comment_bn')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-textarea
                                    id="comments_bn"
                                    v-model="dataArray.comments_bn"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-textarea>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                          </b-col>
                      </b-row>
                      <div class="row">
                        <div class="col-sm-3"></div>
                          <div class="col text-right">
                            <b-button type="submit" variant="primary" class="mr-1">{{ $t('retailerManagement.adjust') }}</b-button>
                            &nbsp;
                            <b-button variant="danger" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                          </div>
                      </div>
                    </b-form>
                  </ValidationObserver>
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { adjustDeliveryOrderStoreApi, singleUserDeliveryOrderApi } from '../../api/routes'
import { core } from '@/config/pluginInit'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.$t('globalTrans.save'),
      dataArray: {
        demmand_id: 0,
        delivery_id: 0,
        type_id: 3,
        user_id: 0,
        return_date: '',
        comments: '',
        comments_bn: '',
        details: []
      },
      sumTotal: 0,
      deliveryAll: [],
      orderIdList: [],
      unitLoad: false
    }
  },
  computed: {
    agentNameList: function () {
      return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
    },
    currentLocale: function () {
        return this.$i18n.locale
    }
  },
  created () {
  },
  watch: {
    'dataArray.user_id': function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.getDeliveryOrders()
      }
    },
    'dataArray.delivery_id': function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.signleOrder()
      } else {
        this.dataArray.details = []
      }
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    getGrandTotal () {
      let sumM = 0
      this.dataArray.details.forEach(function (data) {
        sumM = sumM + parseFloat(data.total)
      })
      this.sumTotal = parseFloat(sumM) ? sumM : 0
    },
    changeQty (item) {
        const result = parseFloat(item.return_quantity) * parseFloat(item.unit_price)
        item.total = parseFloat(result.toFixed(2))
        this.getGrandTotal()
        this.changeWastedQty(item)
    },
    changeWastedQty (item) {
      item.good_product_qty = item.return_quantity - item.wasted_product_qty
    },
    getCategoryName (Id) {
      const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === Id)
      if (typeof product !== 'undefined') {
        const Obj = this.$store.state.ProductionService.commonObj.productCategoryList.find(el => el.value === product.category_id)
        return typeof Obj !== 'undefined' ? (this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn) : ''
      }
      return ''
    },
    productNameById (id) {
        const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    unitNameById (id) {
      const unit = this.$store.state.ProductionService.commonObj.productUnitList.find(unit => unit.value === id)
      if (this.$i18n.locale === 'bn') {
          return unit.text_bn
      } else {
          return unit.text_en
      }
    },
    signleOrder () {
      const tmpData = this.deliveryAll.find(item => item.id === this.dataArray.delivery_id)
      const tmp = JSON.parse(JSON.stringify(tmpData))
      this.dataArray.delivery_location = tmp.delivery_location
      this.dataArray.contact_no = tmp.contact_no
      this.dataArray.demmand_id = tmp.demmand_id
      this.dataArray.delivery_date = tmp.delivery_date

      this.dataArray.details = tmp.delivery_details.map(item => {
        const returnQty = item.returned_quantity ? parseInt(item.returned_quantity) : 0
        const rcvQty = item.received_quantity ? parseInt(item.received_quantity) : 0
        return Object.assign(item, {}, {
          select: 1,
          total: 0,
          wasted_product_qty: 0,
          good_product_qty: 0,
          received_quantity: rcvQty,
          returned_quantity: returnQty,
          return_quantity: 0
        })
      })
    },
    async getDeliveryOrders () {
      this.unitLoad = true
      const result = await RestApi.getData(productionServiceBaseUrl, singleUserDeliveryOrderApi + '/' + this.dataArray.user_id)
      this.unitLoad = false
      if (result.success) {
        this.deliveryAll = result.data
        this.orderIdList = result.data.map(el => {
          return { value: el.id, text: (el.product_type === 1 ? 'P-' : 'W-') + el.delivery_id }
        })
      } else {
        this.deliveryAll = []
        this.orderIdList = []
        this.dataArray.details = []
      }
    },
    async saveData () {
      const isSelect = this.dataArray.details.find(el => parseInt(el.select) === 1)
      if (typeof isSelect !== 'undefined') {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          let result = null
          const loadingState = { loading: false, listReload: false }
          this.unitLoad = true
          result = await RestApi.postData(productionServiceBaseUrl, adjustDeliveryOrderStoreApi, this.dataArray)

          loadingState.listReload = true
          this.$store.dispatch('mutateCommonProperties', loadingState)
          this.unitLoad = false
          if (result.success) {
              if (result.notification && this.$store.state.emitNotification) {
                  const notification = result.notification
                  this.$socket.emit('send-notification', notification)
              }
              this.$toast.success({
                  title: this.$t('globalTrans.success'),
                  message: this.$t('globalTrans.save_msg'),
                  color: '#D6E09B'
              })
              this.$bvModal.hide('modal-4')
          } else {
              this.$refs.form.setErrors(result.errors)
              this.$toast.error({
                  title: this.$t('globalTrans.error'),
                  message: result.message,
                  color: '#D6E09B'
              })
          }
      } else {
        this.$toast.error({
            title: this.$t('globalTrans.error'),
            message: this.$i18n.locale === 'en' ? 'Select at least one item' : 'অন্তত একটি আইটেম নির্বাচন করুন',
            color: '#D6E09B'
        })
      }
    }
  }
}
</script>
